var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportEmailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.516,
    height: 86.38,
    viewBox: "0 0 101.516 86.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "speech-bubble",
    transform: "translate(0 -36.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(0 36.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M81.86,83.153V45.872A9.389,9.389,0,0,0,72.488,36.5H9.372A9.389,9.389,0,0,0,0,45.872V83.153a9.389,9.389,0,0,0,9.372,9.372h2.675v11.238a3.756,3.756,0,0,0,3.774,3.753h0a3.786,3.786,0,0,0,2.841-1.306L30.5,92.5H72.509A9.353,9.353,0,0,0,81.86,83.153ZM29.319,87.445a2.551,2.551,0,0,0-1.928.871L17.106,100.2V89.974a2.549,2.549,0,0,0-2.55-2.55H9.372A4.3,4.3,0,0,1,5.08,83.132V45.872A4.3,4.3,0,0,1,9.372,41.58H72.488a4.3,4.3,0,0,1,4.292,4.292V83.153a4.3,4.3,0,0,1-4.292,4.292Z",
    transform: "translate(0 -36.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M203.2,180.23a3.7,3.7,0,0,0,2.82,1.306,3.757,3.757,0,0,0,1.327-.249,3.717,3.717,0,0,0,2.447-3.525V166.525h2.675a9.389,9.389,0,0,0,9.372-9.372V119.872a9.389,9.389,0,0,0-9.372-9.372,2.54,2.54,0,1,0,0,5.08,4.3,4.3,0,0,1,4.292,4.292v37.281a4.3,4.3,0,0,1-4.292,4.292h-5.2a2.548,2.548,0,0,0-2.55,2.55v10.222L194.43,162.336a2.519,2.519,0,0,0-1.928-.871H154.35a2.55,2.55,0,1,0,0,5.1h36.99Z",
    transform: "translate(-120.325 -95.156)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 3.027,
    cy: 3.027,
    r: 3.027,
    transform: "translate(37.903 25.877)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 3.027,
    cy: 3.027,
    r: 3.027,
    transform: "translate(48.042 25.877)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 3.027,
    cy: 3.027,
    r: 3.027,
    transform: "translate(27.764 25.877)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportEmailLogo);
export default __webpack_public_path__ + "static/media/support-email-logo.60370ab904c17449c68a2ff45bd9e159.svg";
export { ForwardRef as ReactComponent };